import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordPage } from '@portal/ui';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
});
